import { useContext } from 'react';
import { PermissionContext } from './permission.context';

export function usePermission() {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermission must be used within the PermissionProvider');
  }
  return context;
}
